/* eslint-disable @next/next/no-img-element */
import { TFunction } from 'i18next'
import { CountryConfig } from './countryconfig'
import {
    appSubjectsKnowsRoute,
    appFeedsRoute,
    appSearchRoute,
    appLibraryRoute,
    appMyKnowsRoute,
    appFlashcardsRoute,
    appChatRoute,
    appCreateKnowsRoute,
    proPlanRoute,
    appSchoolGptRoute,
    proPlanParentRoute,
} from './routes'
import HomeIcon from 'assets/app/sidebar/home.svg'
import SearchIcon from 'assets/app/sidebar/search.svg'
import LibraryIcon from 'assets/app/sidebar/library.svg'
import MyContentIcon from 'assets/app/sidebar/my_content.svg'
import FlashcardsIcon from 'assets/app/sidebar/flashcard.svg'
import CreateContentIcon from 'assets/app/sidebar/add_content.svg'
import ChatIcon from 'assets/app/sidebar/chat.svg'
import SubjectsIcon from 'assets/app/sidebar/subject.svg'
import PlusPlanIcon from 'assets/app/sidebar/plus_plan.svg'
import { User, UserPremiumStatus } from 'interfaces/User'
import SchoolGPTIcon from 'assets/app/sidebar/school_gpt_icon.png'
import { AcademicTier } from 'interfaces/University'
import { CountryCode } from 'interfaces/Country'

export const isAppPageActive = (activePage: string, route: string, connectedRoute?: string) =>
    activePage.split('?')[0] === route || activePage.split('?')[0] === connectedRoute

export const getSidebarItems = (
    countryConfig: CountryConfig | null,
    t: TFunction<'common'>,
    activePage: string,
    user: User | null,
    isKnower?: boolean
) => [
    {
        name: t('common/navBarHomeLink'),
        to: appFeedsRoute,
        condition: true,
        icon: <HomeIcon />,
    },
    {
        name: t('common/searchButtonLabel'),
        to: appSearchRoute,
        condition: true,
        icon: <SearchIcon />,
    },
    {
        name: user?.academicTier === AcademicTier.University ? 'Uni-GPT' : 'SchoolGPT',
        to: appSchoolGptRoute,
        condition: true,
        icon: <img src={SchoolGPTIcon.src} width={SchoolGPTIcon.width} height={SchoolGPTIcon.height} alt="SchoolGPT" />,
    },
    {
        name: t('common/navBarMyKnowsLink'),
        to: appMyKnowsRoute,
        condition: isKnower,
        icon: <MyContentIcon />,
    },
    {
        name: t('common/navBarKnowLibraryLink'),
        to: appLibraryRoute,
        condition: true,
        icon: <LibraryIcon />,
        connentedRoute: '/app/library/[slug]',
    },
    {
        name: t('common/navBarMenuSubjectMenuItem'),
        to: appSubjectsKnowsRoute,
        condition: false,
        icon: <SubjectsIcon />,
    },
    {
        name: t('common/navBarFlashcardMenuItem'),
        to: appFlashcardsRoute,
        condition: false,
        icon: <FlashcardsIcon />,
    },
    {
        name: t('common/navBarCreateKnowLink'),
        to: appCreateKnowsRoute,
        condition: true,
        icon: <CreateContentIcon />,
    },
    {
        name: t('common/navBarChatMenuItem'),
        to: appChatRoute,
        condition: true,
        icon: <ChatIcon />,
    },
    {
        name: t('common/navBarPlusPlanLink'),
        to: user?.country.code === CountryCode.Brazil ? proPlanParentRoute() : proPlanRoute,
        condition: countryConfig?.hasPlusPlan && user?.premiumStatus === UserPremiumStatus.None,
        icon: <PlusPlanIcon />,
        openInNewTab: true,
    },
]
